import React from 'react';
import {Table} from '..';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'elevatorName',
    numeric: false,
    disabledPadding: true,
    label: 'Elevator',
  },
  {
    id: 'imei',
    numeric: false,
    disabledPadding: false,
    label: 'IMEI',
  },
  {
    id: 'description',
    numeric: false,
    disabledPadding: false,
    label: 'Description',
  },
  {
    id: 'priority',
    numeric: false,
    disabledPadding: false,
    label: 'Priority',
  },
  {
    id: 'time',
    numeric: false,
    disabledPadding: true,
    label: 'Time',
  },
];

const DATA_CELLS = ['elevatorName', 'imei', 'description', 'priority', 'time'];

const LogsTable = ({logs, loading}) => {
  const tableOrder = useTableSort('asc', 'time');

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={logs}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      noToolbar
      {...tableOrder}
    />
  );
};

export default LogsTable;
